import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mv="30px">
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="15px auto" maxWidth="2000px">
          <CFImage src={promotions} w="92%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
